import { useEffect, useRef, useState } from 'react'
import { isPaypalConfigured, loadPaypalSdk, paypalPlanId } from '../lib/paypal'
import { auth, verifyPaypalSubscription } from '../firebase'
import BackButton from '../components/BackButton'

function Subscription({ profile, onSubscribed, onBack }) {
  const containerRef = useRef(null)
  const onSubscribedRef = useRef(onSubscribed)
  const [loading, setLoading] = useState(isPaypalConfigured)
  const [verifying, setVerifying] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    onSubscribedRef.current = onSubscribed
  }, [onSubscribed])

  useEffect(() => {
    if (!isPaypalConfigured) {
      return
    }

    let cancelled = false
    const container = containerRef.current

    loadPaypalSdk()
      .then((paypal) => {
        if (cancelled || !container) {
          return
        }

        paypal
          .Buttons({
            style: { shape: 'pill', color: 'blue', layout: 'vertical', label: 'subscribe' },
            // custom_id ata la suscripcion al uid; la Cloud Function lo valida
            // para que el pago de una cuenta no active otra.
            createSubscription: (_data, actions) =>
              actions.subscription.create({ plan_id: paypalPlanId, custom_id: auth?.currentUser?.uid }),
            onApprove: async (data) => {
              setError('')
              setVerifying(true)
              try {
                const result = await verifyPaypalSubscription(data.subscriptionID)
                onSubscribedRef.current({
                  subscriptionId: data.subscriptionID,
                  startedAt: result?.startedAt ?? new Date().toISOString(),
                })
              } catch {
                setError(
                  'PayPal aprobo el pago pero no pudimos confirmarlo. Si el cobro se realizo, escribinos para activar tu membresia manualmente.',
                )
              } finally {
                setVerifying(false)
              }
            },
            onError: () => setError('Hubo un problema con PayPal. Intenta de nuevo.'),
          })
          .render(container)

        setLoading(false)
      })
      .catch(() => {
        if (!cancelled) {
          setError('No pude cargar PayPal. Revisa tu conexion.')
          setLoading(false)
        }
      })

    return () => {
      cancelled = true
      if (container) {
        container.innerHTML = ''
      }
    }
  }, [])

  return (
    <main className="screen subscription-screen">
      <section className="onboarding-card subscription-card">
        {onBack && <BackButton onClick={onBack} />}
        <p className="eyebrow">Ultimo paso</p>
        <h1>Activa tu membresia</h1>
        <p className="subtitle">
          {profile.fullName}, tu perfil ya esta listo. Suscribite para desbloquear el calendario, el seguimiento
          diario y tu dashboard de progreso.
        </p>

        <ul className="subscription-benefits">
          <li>Calendario de entrenamiento generado para tu nivel</li>
          <li>Seguimiento de racha y progreso semanal</li>
          <li>Historial mensual exportable a CSV</li>
        </ul>

        {!isPaypalConfigured && (
          <p className="error-text">
            La suscripcion todavia no esta configurada. Falta cargar REACT_APP_PAYPAL_CLIENT_ID y
            REACT_APP_PAYPAL_PLAN_ID en el .env.
          </p>
        )}

        {loading && <p className="subtitle">Cargando PayPal...</p>}
        {verifying && <p className="subtitle">Confirmando tu pago con PayPal...</p>}
        {error && <p className="error-text">{error}</p>}

        <div ref={containerRef} className="paypal-button-container" style={verifying ? { pointerEvents: 'none', opacity: 0.6 } : undefined} />
      </section>
    </main>
  )
}

export default Subscription
